import { useMutation, useQuery } from "@tanstack/react-query"
import { LoginService, type SwitchOrganizationRequest } from "../client"

/**
 * Hook to fetch all organizations the current user belongs to.
 */
export function useOrganizations() {
  return useQuery({
    queryKey: ["my-organizations"],
    queryFn: () => LoginService.getMyOrganizations(),
  })
}

/**
 * Hook to switch to a different organization.
 * This will:
 * 1. Call the switch-organization endpoint to get a new token
 * 2. Update the token in localStorage
 * 3. Invalidate all queries to refetch data for the new organization
 */
export function useSwitchOrganization() {
  return useMutation({
    mutationFn: (body: SwitchOrganizationRequest) =>
      LoginService.switchOrganization({ requestBody: body }),
    onSuccess: (data) => {
      // Update the token in localStorage
      localStorage.setItem("access_token", data.access_token)
    },
  })
}
